import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as CheckmarkCircle } from '../../../../assets/icons/checkmark-circle.svg'
import { useResponsesStore } from '../../../../stores/responsesStore'

import styles from './add-response.module.scss'

function AddResponse() {
    const { t } = useTranslation()

    const [, { addResponseContent }] = useResponsesStore()

    const [text, setText] = useState('')

    const handleAddResponseContent = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()

        text && addResponseContent({ text })
        setText('')
    }

    return (
        <form
            className={styles.addResponse}
            onSubmit={handleAddResponseContent}
        >
            <input
                className={styles.addResponse__input}
                type="text"
                id="responseContent"
                value={text}
                onChange={(e) => setText(e.target.value)}
            />
            <button className={styles.addResponse__addBtn} type="submit">
                <CheckmarkCircle alt={t('add')} />
                {t('confirm')}
            </button>
        </form>
    )
}

export default AddResponse
